<template>
  <div class="fieldYesNo">
    <div class="row" :class="errorClass">
      <div class="col-md-4 col-lg-4 col-xl-3">
        <label class="h6 text-md-right">
          <span v-html="label"></span> <br>
          <small class="text-black-50">{{labelSecondary}}</small>
        </label>
      </div>
      <div class="col-md-8 col-lg-8 col-xl-9">
        <div class="form-check form-check-inline">
          <input :required="isRequired" class="form-check-input" type="radio" name="inlineRadioOptions" id="leadership-yes" v-on:click="showSecondaryFields = true">
          <label class="form-check-label" for="leadership-yes">Yes</label>
        </div>
        <div class="form-check form-check-inline">
          <input :required="isRequired" class="form-check-input" type="radio" name="inlineRadioOptions" id="leadership-no" v-on:click="selectedNotLeader()">
          <label class="form-check-label" for="leadership-no">No</label>
        </div>
      </div>
    </div>
    <transition name="grow">
      <div v-if="showSecondaryFields" class="row" :class="errorClass">
        <div class="col-md-4 col-lg-4 col-xl-3">
          <label class="h6 text-md-right">
            <span v-html="labelLvl2"></span> <br>
            <small class="text-black-50">{{labelSecondaryLvl2}}</small>
          </label>
        </div>
        <div class="col-md-8 col-lg-8 col-xl-9">
          <div class="form-group clearfix">
            <textarea
              v-model="textContent"
              class="form-control"
              rows="3"
              placeholder="In less than 150 words"
              v-on:keyup="checkWordsRemaining()"
              :class="wordCountWarning"
              :required="showSecondaryFields">
            </textarea>
            <small class="float-right text-black-50" :class="'small-' + wordCountWarning">You have {{wordsRemaining}} words left</small>
          </div>
          <div v-if="errorClass !== ''" class="alert alert-danger mt-1" role="alert">
            Please complete this field
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>

export default {
  props: [
    'label',
    'labelSecondary',
    'labelLvl2',
    'labelSecondaryLvl2',
    'isRequired',
    'errorClass'
  ],
  data () {
    return {
      wordsRemaining: 150,
      textContent: '',
      wordCountWarning: '',
      showSecondaryFields: false
    }
  },
  methods: {
    selectedNotLeader: function () {
      this.showSecondaryFields = false
      this.$emit('addedYesNoContent', {label: this.label, content: 'No', validated: true})
    },
    checkWordsRemaining: function (event) {
      this.wordsRemaining = 150 - this.textContent.split(' ').length + 1
      if (this.wordsRemaining < 0) {
        this.wordCountWarning = 'word-count-exceeded'
      } else {
        this.wordCountWarning = ''
      }
      this.$emit('addedYesNoContent', {label: this.label, content: 'Yes: ' + this.textContent, validated: this.wordsRemaining >= 0 && this.textContent.length > 0})
    }
  }
}
</script>

<style lang="less">
  .word-count-exceeded {
    border-color: red !important;
    background: lightyellow;
  }
  .small-word-count-exceeded {
    color: red !important;
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/components/FieldYesNo150Word.vue